<template>
  <v-data-table
    v-bind="this.$attrs"
    :options.sync="studentTableOptions"
    loading-text="Đang Tải"
    item-key="id"
    :headers="headers"
    :items="classesData"
    :server-items-length="totalItems"
    :search="search"
    :loading="loading"
    :footer-props="footerTable"
    no-data-text="Không có lớp"
    disable-sort
  >
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small class="white--text" v-if="item.status" :color="item.status | classStatusColor" label>
        {{ item.status | classStatus }}
      </v-chip>
    </template>
    <template v-slot:[`item.title`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on" style="text-decoration: none; white-space: nowrap">
            <router-link v-on="on" style="text-decoration: none; white-space: nowrap" :to="'/class/' + item.id">{{
              item.title
            }}</router-link>
          </div>
        </template>
        <span>Xem lớp</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.type`]="{ item }">
      {{ item.type | classType }}
    </template>
    <template v-slot:[`item.studentCount`]="{ item }">
      <p style="margin: 0; white-space: nowrap">
        {{ item.students | getStudentCount }}
      </p>
    </template>
    <template v-slot:[`item.teacher`]="{ item }">
      <div v-if="!item.teachers || item.teachers.length === 0">--</div>
      <template v-else>
        <CardTeacherName v-for="(teacher, index) in item.teachers" :key="index" :teacher="teacher" link />
      </template>
    </template>
    <template v-slot:[`item.beginningDate`]="{ item }">
      <p style="margin: 0; white-space: nowrap">
        {{ get(item, 'beginningDate') ? moment(get(item, 'beginningDate')).format('DD/MM/YYYY') : '' }}
      </p>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'

import moment from 'moment'
import get from 'lodash-es/get'

const originHeaders = [
  { text: 'Tên lớp', value: 'title' },
  { text: 'Giáo viên giảng dạy', value: 'teacher' },
  { text: 'Sĩ số', value: 'studentCount', align: 'center' },
  { text: 'Trạng thái', value: 'status' },
  { text: 'Ngày khai giảng', value: 'beginningDate', align: 'end' },
]
export default {
  components: { CardTeacherName },
  props: {},
  data() {
    return {
      headers: originHeaders,
      draw: false,
      search: '',
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      editClassId: '',
      dialog: false,
      studentTableOptions: {},
      moment,
      get,
    }
  },
  async created() {
    await this.refresh()
  },
  computed: {
    ...mapState('class', ['classData', 'classesData', 'totalItems', 'pageText', 'loading']),
    ...mapGetters('auth', ['role', 'profile']),
    ...mapGetters('class', ['classes']),

    footerTable() {
      let footer = {
        'items-per-page-text': 'Số dòng mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  methods: {
    ...mapActions('class', [
      'fetchClasses',
      'setClass',
      'setClasses',
      'updateClasses',
      'removeClasses',
      'searchClasses',
      'requestPageSettings',
    ]),

    async refresh(query) {
      query = query || {}
      if (this.role.type === 'teacher') {
        query.headTeachers = [this.profile.id]
      }

      this.searchClasses({
        status: 'running',
        ...query,
      })
    },
  },
  filters: {
    getStudentCount(students) {
      return students.filter((s) => s.status === 'active').length
    },
    getTeacherNames: (classData) => {
      return classData.headTeachers.map((teacher) => teacher.name).join(', ')
    },
  },
  watch: {
    studentTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>
